module.exports = __webpack_public_path__ + "static/img/8_new.ca3b8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/8_new.png
// module id = 1QGD
// module chunks = 4